<script>
  import moment from "moment";
  import { onMount, createEventDispatcher } from "svelte";
  import { apiGet, apiPost, apiDelete } from "../httpCommon";
  import { ResourceShow } from "../components";
  import Button, { Label, Icon } from "@smui/button";

  const dispatch = createEventDispatcher();

  export let id = null;
  export let title = "";
  export let topLevel = true;
  export let data = null;
  let loadingXero = false;

  if (data && !id) {
    id = data.id;
  }

  $: canDelete =
    data &&
    (!data.xero_invoice_ref ||
      (data.xero_invoice && data.xero_invoice.Status === "DRAFT"));

  $: {
    if (data) {
      title = `Invoice: ${data.invoice_ref || ""}`;
    }
  }

  $: {
    if (data && data.xero_invoice_ref && !data.xero_invoice) {
      loadXeroInvoice();
    }
  }

  async function loadXeroInvoice() {
    if (loadingXero) return;

    try {
      loadingXero = true;
      data.xero_invoice = await apiGet(`/invoices/${id}/xero-invoice`);
    } catch (error) {
    } finally {
      loadingXero = false;
    }
  }

  async function sendToXero() {
    try {
      data = await apiPost(`/invoices/${id}/send-to-xero`, { update: true });
    } catch (error) {
      console.log("Error sending to Xero: ", error);
    }
  }

  async function deleteItem() {
    try {
      await apiDelete("/invoices", id);
      dispatch("deleted");
    } catch (error) {}
  }
</script>

<style>
  .fees th,
  .fees td {
    text-align: right;
    padding-right: 10px;
  }
</style>

{(console.log('canDelete: ', canDelete), '')}
<ResourceShow resource="invoices" bind:data {id} {topLevel}>
  <div slot="title" class="flex">
    <span>{title}</span>
    {#if canDelete}
      <Button on:click={deleteItem}>
        <Icon class="material-icons">delete</Icon>
        <Label>Delete</Label>
      </Button>
    {/if}
  </div>
  <div slot="content">
    {#if data}
      <p>
        <strong>Invoice Date:</strong>
        {moment(data.invoice_date).format('Do MMM')}
      </p>
      <div class="flex no-spread wrap">
        <table class="fees">
          <tr>
            <th>Food Disco Fees:</th>
            <td>{data.fd_fee_exc_vat}</td>
          </tr>
          <tr>
            <th>VAT @ {data.fd_tax_rate * 100}%:</th>
            <td>{data.fd_tax_amount}</td>
          </tr>
          <tr>
            <th>Total:</th>
            <td>{data.fd_fee_total}</td>
          </tr>
        </table>
        <table class="fees">
          <tr>
            <th>Total takings:</th>
            <td>{data.total_takings}</td>
          </tr>
          <tr>
            <th>CC fees:</th>
            <td>{data.total_cc_fees}</td>
          </tr>
          <tr>
            <th>FD fees:</th>
            <td>{data.fd_fee_total}</td>
          </tr>
          <tr>
            <th>Vendor dues:</th>
            <td>{data.vendor_dues}</td>
          </tr>
        </table>
      </div>
      <div>
        {#if data.xero_invoice_ref}
          <p>
            <span>Xero Invoice:</span>
            <a
              href="https://invoicing.xero.com/view/{data.xero_invoice_ref}"
              target="_blank">
              {data.xero_invoice_ref}
            </a>
          </p>
          <p>
            {#if data.xero_invoice}Xero Status: {data.xero_invoice.Status}{/if}
          </p>
          {#if canDelete}
            <p>
              <Button on:click={sendToXero}>
                <Label>Update in xero</Label>
              </Button>
            </p>
          {/if}
        {:else}
          <Button on:click={sendToXero}>
            <Label>Create in xero</Label>
          </Button>
        {/if}
      </div>
    {/if}
  </div>
</ResourceShow>
